import { launchpadDefinitions, LaunchpadId } from '@/constants/launchpads';

import { launchpadAvatarRadius } from '@/ui/Avatars/LaunchpadAvatar';
import { MultiselectItem } from '@/ui/Multiselect';

import { otherLaunchpads } from '@/utils/discovery/types';

export const timeframeList = [
  { label: '1h', value: '1' },
  { label: '4h', value: '4' },
  { label: '12h', value: '12' },
  { label: '24h', value: '24' },
] as const;

export const socialTypeList: MultiselectItem[] = [
  {
    value: LaunchpadId.ZORA,
    label: launchpadDefinitions[LaunchpadId.ZORA].name,
    icon: launchpadDefinitions[LaunchpadId.ZORA].logo,
    iconAlt: launchpadDefinitions[LaunchpadId.ZORA].name,
    iconRadius: launchpadAvatarRadius,
  },
  {
    value: LaunchpadId.ZORA_CREATOR,
    label: launchpadDefinitions[LaunchpadId.ZORA_CREATOR].name,
    icon: launchpadDefinitions[LaunchpadId.ZORA_CREATOR].logo,
    iconAlt: launchpadDefinitions[LaunchpadId.ZORA_CREATOR].name,
    iconRadius: launchpadAvatarRadius,
  },
  {
    value: LaunchpadId.BASEAPP,
    label: launchpadDefinitions[LaunchpadId.BASEAPP].name,
    icon: launchpadDefinitions[LaunchpadId.BASEAPP].logo,
    iconAlt: launchpadDefinitions[LaunchpadId.BASEAPP].name,
    iconRadius: launchpadAvatarRadius,
  },
];

export const launchpadList: MultiselectItem[] = otherLaunchpads.map((launchpad) => ({
  value: launchpad,
  label: launchpadDefinitions[launchpad].name,
  icon: launchpadDefinitions[launchpad].logo,
  iconAlt: `${launchpadDefinitions[launchpad].name} launchpad`,
  iconRadius: launchpadAvatarRadius,
}));
